import { useMemo } from 'react';

import {
  S9ComponentConfig,
  S9ComponentConfigCategory,
  S9ComponentConfigRelease,
} from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { ApplicationDocument } from '../../models/stack9/ApplicationDocument';

const S9Button = ui.S9Button.default;

export const config: S9ComponentConfig = {
  name: 'FileView',
  icon: '',
  category: S9ComponentConfigCategory.GENERAL,
  version: S9ComponentConfigRelease.ALPHA,
  hasState: true,
  allowChildren: false,
  props: [],
};

type FileViewProps = {
  row: ApplicationDocument;
};

const FileView = ({ row }: FileViewProps) => {
  const { file } = row;

  const fileItems = useMemo(() => {
    const items: ApplicationDocument['file'] = [];

    if (!file) {
      return items;
    }

    if (Array.isArray(file)) {
      items.push(...file);
    } else if (typeof file === 'object' && 'fileKey' in file) {
      items.push(file);
    }

    return items;
  }, [file]);

  if (!fileItems.length) {
    return <>-</>;
  }

  return (
    <ul className="space-y-1.5">
      {fileItems.map((item, idx) => (
        <li
          key={item.name + item.fileKey}
          className="flex items-start justify-between flex-wrap gap-2"
        >
          <span>{idx + 1}. </span>

          <span className="grow">{item.name}</span>

          <S9Button
            icon="ExportOutlined"
            type="text"
            htmlType="button"
            href={
              item &&
              ui.Utils.signPrivateBucketURLRoute(
                'application_document',
                item.fileKey,
                item.isPublic,
              )
            }
            label="View"
            target="_blank"
          />
        </li>
      ))}
    </ul>
  );
};

export default FileView;
